<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="accounts">
                <ul>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            <div class="search">
                <form action="search-results.html" method="get" style="align-items: flex-start;">

                    <input id="search" name="search" type="text" [(ngModel)]="trserial" (keyup)="retriveIPrepLookUp()"  placeholder="Serial" >
                    <label>                      </label>
                    <input id="search" name="search" type="text" [(ngModel)]="supname" (keyup)="retriveIPrepLookUp()" placeholder="Name" >

                </form>
            </div>
        </div>
    </div>
  </section>

  <table style="Height: 15px;">
    <thead>
        <tr >
            <th style="width: 15%;height: 5px;">{{ 'Serial' | translate }}</th>
            <th style="width: 15%;height: 5px;">{{ 'Date' | translate }}</th>
            <th style="width: 60%;height: 5px;">{{ 'Supplier' | translate }}</th>
            <th style="width: 10%;height: 5px;">Choose</th>
        </tr>
    </thead>
    <tbody>
      <tr *ngFor="let pro of transactionsList; let i = index">
            <td data-column="Protocol ID">{{pro.trserial}}</td>
            <td data-column="Document Date">{{pro.trdate}}</td>
            <td data-column="Protocol Name">{{pro.supname}}</td>
            <td data-column="Choose"><button type="button" class="theme-button btn" name="select" id="select" (click)="SelectItem(pro)">Select</button>
            </td>
        </tr>

    </tbody>
  </table>
  </mat-dialog-content>



